import {
  PERMISSION_ACTION_CODES,
  PERMISSION_RESOURCE_CODES,
} from './definitions';
import { buildPermissionKey } from './helpers';

export const getAllPermissionKeys = (): string[] => {
  const keys = new Set<string>();
  const permissionEntries: Array<{
    resourceCode: string;
    actionCodes: string[];
  }> = [
    {
      resourceCode: PERMISSION_RESOURCE_CODES.dashboard,
      actionCodes: Object.values(PERMISSION_ACTION_CODES.dashboard),
    },
    {
      resourceCode: PERMISSION_RESOURCE_CODES.invoicesMy,
      actionCodes: Object.values(PERMISSION_ACTION_CODES.invoicesMy),
    },
    {
      resourceCode: PERMISSION_RESOURCE_CODES.invoicesAll,
      actionCodes: Object.values(PERMISSION_ACTION_CODES.invoicesAll),
    },
    {
      resourceCode: PERMISSION_RESOURCE_CODES.claimsMy,
      actionCodes: Object.values(PERMISSION_ACTION_CODES.claimsMy),
    },
    {
      resourceCode: PERMISSION_RESOURCE_CODES.claimsAll,
      actionCodes: Object.values(PERMISSION_ACTION_CODES.claimsAll),
    },
    {
      resourceCode: PERMISSION_RESOURCE_CODES.approval,
      actionCodes: Object.values(PERMISSION_ACTION_CODES.approval),
    },
    {
      resourceCode: PERMISSION_RESOURCE_CODES.myAnalytics,
      actionCodes: Object.values(PERMISSION_ACTION_CODES.myAnalytics),
    },
    {
      resourceCode: PERMISSION_RESOURCE_CODES.managementCockpit,
      actionCodes: Object.values(PERMISSION_ACTION_CODES.managementCockpit),
    },
    {
      resourceCode: PERMISSION_RESOURCE_CODES.specialAnalytics,
      actionCodes: Object.values(PERMISSION_ACTION_CODES.specialAnalytics),
    },
    {
      resourceCode: PERMISSION_RESOURCE_CODES.settingsReimbursement,
      actionCodes: Object.values(PERMISSION_ACTION_CODES.settingsReimbursement),
    },
    {
      resourceCode: PERMISSION_RESOURCE_CODES.anomalyRules,
      actionCodes: Object.values(PERMISSION_ACTION_CODES.anomalyRules),
    },
    {
      resourceCode: PERMISSION_RESOURCE_CODES.expenseCategories,
      actionCodes: Object.values(PERMISSION_ACTION_CODES.expenseCategories),
    },
    {
      resourceCode: PERMISSION_RESOURCE_CODES.sceneTemplates,
      actionCodes: Object.values(PERMISSION_ACTION_CODES.sceneTemplates),
    },
    {
      resourceCode: PERMISSION_RESOURCE_CODES.expenseStandardPolicies,
      actionCodes: Object.values(
        PERMISSION_ACTION_CODES.expenseStandardPolicies,
      ),
    },
    {
      resourceCode: PERMISSION_RESOURCE_CODES.personalQuotaConfigs,
      actionCodes: Object.values(PERMISSION_ACTION_CODES.personalQuotaConfigs),
    },
    {
      resourceCode: PERMISSION_RESOURCE_CODES.permissions,
      actionCodes: Object.values(PERMISSION_ACTION_CODES.permissions),
    },
  ];

  permissionEntries.forEach(({ resourceCode, actionCodes }) => {
    keys.add(resourceCode);
    actionCodes.forEach((actionCode) => {
      keys.add(buildPermissionKey(resourceCode, actionCode));
    });
  });

  return Array.from(keys);
};
